module.exports = __webpack_public_path__ + "media/images/allow_down_right-b930c3cbe56bcf2f89c1b3012c845ee6.svg";